<script lang="ts">
	import type { Device } from 'src/types/Device';
	import BluetoothSensorAdvancedView from 'src/components/Sidepanel/DeviceViews/BluetoothSensor/BluetoothSensorAdvancedView.svelte';

	export let device: Device;
</script>

<BluetoothSensorAdvancedView {device} />
